module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "aria-label": "9",
      "epub:type": "pagebreak",
      "id": "page9",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“A daughter without her mother is a woman broken. It is a loss that turns to arthritis and settles deep into her bones.”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-right-space-after"
  }, [_vm._v("—"), _c('span', {
    staticClass: "custom-0"
  }, [_vm._v("Kristin Hannah, ")]), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("Summer Island")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“Tragedy should be utilized as a source of strength. No matter what sort of difficulties, how painful experience is, if we lose our hope, that’s our real disaster.”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-right-space-after"
  }, [_vm._v("—"), _c('span', {
    staticClass: "custom-0"
  }, [_vm._v("Dalai Lama XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“Imagine a future where we could edit a sick person’s DNA to make them better … there are a lot of questions about how to use this technology responsibly. But I’m hopeful about the possibilities.” ")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-right"
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "custom-0"
  }, [_vm._v("Bill Gates, ")]), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("Time")]), _c('span', {
    staticClass: "custom-0"
  }, [_vm._v(","), _c('br'), _vm._v("January 4, 2018")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-031c17b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504095785-0.vue
// module id = 75
// module chunks = 0